module.exports = __webpack_public_path__ + "static/media/YF15_1.3a564e78.jpg";